import { CityProvince } from '../interfaces/Location/Location'

export const provinces: CityProvince[] = [
  { stateId: 1, cityId: 11, name: 'Iquique' },
  { stateId: 1, cityId: 14, name: 'Tamarugal' },
  { stateId: 2, cityId: 21, name: 'Antofagasta' },
  { stateId: 2, cityId: 22, name: 'El Loa' },
  { stateId: 2, cityId: 23, name: 'Tocopilla' },
  { stateId: 3, cityId: 31, name: 'Copiapó' },
  { stateId: 3, cityId: 32, name: 'Chañaral' },
  { stateId: 3, cityId: 33, name: 'Huasco' },
  { stateId: 4, cityId: 41, name: 'Elqui' },
  { stateId: 4, cityId: 42, name: 'Choapa' },
  { stateId: 4, cityId: 43, name: 'Limarí' },
  { stateId: 5, cityId: 51, name: 'Valparaíso' },
  { stateId: 5, cityId: 52, name: 'Isla de Pascua' },
  { stateId: 5, cityId: 53, name: 'Los Andes' },
  { stateId: 5, cityId: 54, name: 'Petorca' },
  { stateId: 5, cityId: 55, name: 'Quillota' },
  { stateId: 5, cityId: 56, name: 'San Antonio' },
  { stateId: 5, cityId: 57, name: 'San Felipe de Aconcagua' },
  { stateId: 5, cityId: 58, name: 'Marga Marga' },
  { stateId: 6, cityId: 61, name: 'Cachapoal' },
  { stateId: 6, cityId: 62, name: 'Cardenal Caro' },
  { stateId: 6, cityId: 63, name: 'Colchagua' },
  { stateId: 7, cityId: 71, name: 'Talca' },
  { stateId: 7, cityId: 72, name: 'Cauquenes' },
  { stateId: 7, cityId: 73, name: 'Curicó' },
  { stateId: 7, cityId: 74, name: 'Linares' },
  { stateId: 8, cityId: 81, name: 'Concepción' },
  { stateId: 8, cityId: 82, name: 'Arauco' },
  { stateId: 8, cityId: 83, name: 'Biobío' },
  { stateId: 9, cityId: 91, name: 'Cautín' },
  { stateId: 9, cityId: 92, name: 'Malleco' },
  { stateId: 10, cityId: 101, name: 'Llanquihue' },
  { stateId: 10, cityId: 102, name: 'Chiloé' },
  { stateId: 10, cityId: 103, name: 'Osorno' },
  { stateId: 10, cityId: 104, name: 'Palena' },
  { stateId: 11, cityId: 111, name: 'Coihaique' },
  { stateId: 11, cityId: 112, name: 'Aisén' },
  { stateId: 11, cityId: 113, name: 'Capitán Prat' },
  { stateId: 11, cityId: 114, name: 'General Carrera' },
  { stateId: 12, cityId: 121, name: 'Magallanes' },
  { stateId: 12, cityId: 122, name: 'Antártica Chilena' },
  { stateId: 12, cityId: 123, name: 'Tierra del Fuego' },
  { stateId: 12, cityId: 124, name: 'Última Esperanza' },
  { stateId: 13, cityId: 131, name: 'Santiago' },
  { stateId: 13, cityId: 132, name: 'Cordillera' },
  { stateId: 13, cityId: 133, name: 'Chacabuco' },
  { stateId: 13, cityId: 134, name: 'Maipo' },
  { stateId: 13, cityId: 135, name: 'Melipilla' },
  { stateId: 13, cityId: 136, name: 'Talagante' },
  { stateId: 14, cityId: 141, name: 'Valdivia' },
  { stateId: 14, cityId: 142, name: 'Ranco' },
  { stateId: 15, cityId: 151, name: 'Arica' },
  { stateId: 15, cityId: 152, name: 'Parinacota' },
  { stateId: 16, cityId: 161, name: 'Diguillín' },
  { stateId: 16, cityId: 162, name: 'Itata' },
  { stateId: 16, cityId: 163, name: 'Punilla' }
]
